import { ReactNode, createContext } from "react";
import useResponsavel, { ResponsavelType, CreateResponsavelType, EditResponsavelType} from "./hooks/useResponsavel";

interface ResponsavelContextProviderProps {
    children: ReactNode;
}

export interface ResponsavelContextData {
    createResponsavel: (createResponsavelData: CreateResponsavelType) => Promise<CreateResponsavelType | null>;
    getResponsavelPaged: (
        pageNumber: number,
        Name?: string,
        EmpresaId?: number,
        InstituicaoId?: number,
        pageSize?: number
    ) => Promise<ResponsavelType[] | null>;
    updateResponsavel: (editResponsavelData: EditResponsavelType) => Promise<EditResponsavelType | null>;
    deleteResponsavel: (responsavelId: number) => Promise<ResponsavelType | null>;
    handleGetResponsavelById: (id: number) => Promise<ResponsavelType | null>;
    setResponsavel: any;
    responsavel: ResponsavelType;
    listResponsavel: ResponsavelType[];
    initialListResponsavel: ResponsavelType[];
    setListResponsavel: (responsavel: ResponsavelType[]) => void;
    setResponsavelPageCount: (count: number) => void;
    responsavelPageCount: number;
    handleGetResponsavelByEmpresaId: (empresaId: number) => Promise<ResponsavelType[] | null>;
    handleGetResponsavelByInstituicaoId: (instituicaoId: number) => Promise<ResponsavelType[] | null>;
}

const initialState: ResponsavelContextData = {
    createResponsavel: async () => null,
    getResponsavelPaged: async () => null,
    updateResponsavel: async () => null,
    deleteResponsavel: async () => null,
    handleGetResponsavelById: async () => null,
    setResponsavel: () => {},
    responsavel: {
        id: 0,
        name: "",
        email: "",
        cpf: "",
        telephone: "",
        position: "",
        bank: "",
        agency: "",
        currentAccount: "",
        observation: "",
        pix: "",
        empresaId: 0,
        instituicaoId: 0,
    },
    listResponsavel: [],
    initialListResponsavel: [],
    setListResponsavel: () => {},
    setResponsavelPageCount: () => {},
    responsavelPageCount: 0,
    handleGetResponsavelByEmpresaId: async () => null,
    handleGetResponsavelByInstituicaoId: async () => null,
};

export const ResponsavelContext =
    createContext<ResponsavelContextData>(initialState);

export default function ResponsavelContextProvider({
    children,
}: ResponsavelContextProviderProps) {
    const {
        createResponsavel,
        getResponsavelPaged,
        updateResponsavel,
        deleteResponsavel,
        handleGetResponsavelById,
        setResponsavel,
        responsavel,
        listResponsavel,
        initialListResponsavel,
        setListResponsavel,
        responsavelPageCount,
        setResponsavelPageCount,
        handleGetResponsavelByEmpresaId,
        handleGetResponsavelByInstituicaoId,
    } = useResponsavel();

    return (
        <ResponsavelContext.Provider
            value={{
                createResponsavel,
                getResponsavelPaged,
                updateResponsavel,
                deleteResponsavel,
                handleGetResponsavelById,
                setResponsavel,
                responsavel,
                listResponsavel,
                initialListResponsavel,
                setListResponsavel,
                setResponsavelPageCount,
                responsavelPageCount,
                handleGetResponsavelByEmpresaId,
                handleGetResponsavelByInstituicaoId,
            }}
        >
            {children}
        </ResponsavelContext.Provider>
    );
}